import { render, staticRenderFns } from "./BookingStands.vue?vue&type=template&id=54c891b9"
import script from "./BookingStands.vue?vue&type=script&lang=js"
export * from "./BookingStands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports